import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { Stack } from '../../../Stack';

export const TableHeaderContainer = styled.div`
    background-color: ${getToken('backgroundInteractiveNeutralSubtleDefault')};
    padding: ${getSpacingToken('200')}px ${getSpacingToken('0')};
`;

export const Title = styled.div<{ hasSubTitle: boolean }>`
    color: ${getToken('textStaticPrimary')};
    ${getTextTokenPreset('titleMediumStrong')};
    margin: ${getSpacingToken('0')};
    padding-right: ${({ hasSubTitle, theme }) => (hasSubTitle ? `${getSpacingToken('100')({ theme })}px` : '0')};
`;

export const SubTitle = styled.div`
    color: ${getToken('textStaticSecondary')};
    ${getTextTokenPreset('titleMedium')};
    margin: ${getSpacingToken('0')};
`;

export const GlobalSearchContainer = styled(Stack)``;
